import React from 'react';
import DataTable from '../../DataTable';
import Modal from '../../Modal';

/**
 * 管理 - 会社管理ページ
 */
function Companies({
  companies,
  companyColumns,
  setCompanyColumns,
  defaultCompanyColumns,
  companySort,
  setCompanySort,
  companyPage,
  setCompanyPage,
  companyPageSize,
  setCompanyPageSize,
  showCompanyModal,
  setShowCompanyModal,
  editingCompany,
  companyForm,
  setCompanyForm,
  handleCreateCompany,
  handleSaveCompany,
  handleEditCompany,
  handleDeleteCompany,
  handleManageOrganization,
  handleManageLocations,
  handleManageWashers,
  setSelectedCompany,
  navigate
}) {
  // 会社データのソートとページング処理
  const getCompanyPageData = () => {
    // ソート処理
    let sortedCompanies = [...companies];
    if (companySort && companySort.column) {
      sortedCompanies.sort((a, b) => {
        const aVal = a[companySort.column];
        const bVal = b[companySort.column];
        
        if (aVal === null || aVal === undefined) return 1;
        if (bVal === null || bVal === undefined) return -1;
        
        let comparison = 0;
        if (typeof aVal === 'string') {
          comparison = aVal.localeCompare(bVal, 'ja');
        } else {
          comparison = aVal < bVal ? -1 : aVal > bVal ? 1 : 0;
        }
        
        return companySort.order === 'asc' ? comparison : -comparison;
      });
    }
    
    // ページング処理
    const startIndex = (companyPage - 1) * companyPageSize;
    const endIndex = startIndex + companyPageSize;
    return sortedCompanies.slice(startIndex, endIndex);
  };

  const renderCompanyCell = (company, column, cellStyle) => {
    switch (column.id) {
      case 'company_id':
        return <td key={column.id} style={cellStyle}>{company.company_id}</td>;
      case 'company_code':
        return <td key={column.id} style={cellStyle}>{company.company_code}</td>;
      case 'company_name':
        return <td key={column.id} style={cellStyle}>{company.company_name}</td>;
      case 'notes':
        return <td key={column.id} style={cellStyle}>{company.notes || '-'}</td>;
      case 'created_at':
        return (
          <td key={column.id} style={cellStyle}>
            {new Date(company.created_at).toLocaleString('ja-JP', { timeZone: 'Asia/Tokyo' })}
          </td>
        );
      case 'actions':
        return (
          <td key={column.id} style={cellStyle}>
            <div className="company-action-buttons">
              <button 
                className="btn btn-sm btn-primary" 
                onClick={() => handleManageOrganization(company)}
              >
                組織階層
              </button>
              <button 
                className="btn btn-sm btn-primary" 
                onClick={() => handleManageLocations(company)}
              >
                設置先階層
              </button>
              <button 
                className="btn btn-sm btn-primary" 
                onClick={() => handleManageWashers(company)}
              >
                洗浄機
              </button>
              <button 
                className="btn btn-sm btn-info" 
                onClick={() => {
                  setSelectedCompany(company);
                  navigate('/management/sensors');
                }}
                title="スーパーアドミン専用"
              >
                センサー
              </button>
              <button 
                className="btn btn-sm btn-secondary" 
                onClick={() => handleEditCompany(company)}
              >
                編集
              </button>
              <button 
                className="btn btn-sm btn-danger" 
                onClick={() => handleDeleteCompany(company.company_id)}
              >
                削除
              </button>
            </div>
          </td>
        );
      default:
        return undefined;
    }
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h2>会社管理</h2>
        <button className="btn btn-primary" onClick={handleCreateCompany}>
          + 会社登録
        </button>
      </div>
      
      <DataTable
        columns={companyColumns}
        data={getCompanyPageData()}
        defaultColumns={defaultCompanyColumns}
        onColumnsChange={setCompanyColumns}
        localStorageKey="companyColumns"
        sortConfig={companySort}
        onSortChange={setCompanySort}
        currentPage={companyPage}
        pageSize={companyPageSize}
        totalItems={companies.length}
        onPageChange={setCompanyPage}
        onPageSizeChange={setCompanyPageSize}
        idField="company_id"
        renderCell={renderCompanyCell}
        emptyMessage="会社情報が登録されていません"
      />

      {/* 会社登録・編集モーダル */}
      {showCompanyModal && (
        <Modal
          title={editingCompany ? '会社情報編集' : '会社情報登録'}
          onClose={() => setShowCompanyModal(false)}
          width="500px"
        >
          <div className="form-group">
            <label>会社コード *</label>
            <input
              type="text"
              value={companyForm.company_code}
              onChange={(e) => setCompanyForm({ ...companyForm, company_code: e.target.value })}
              placeholder="例: COMPANY001"
            />
          </div>

          <div className="form-group">
            <label>会社名 *</label>
            <input
              type="text"
              value={companyForm.company_name}
              onChange={(e) => setCompanyForm({ ...companyForm, company_name: e.target.value })}
              placeholder="例: デモ株式会社"
            />
          </div>

          <div className="form-group">
            <label>備考</label>
            <textarea
              value={companyForm.notes}
              onChange={(e) => setCompanyForm({ ...companyForm, notes: e.target.value })}
              placeholder="備考を入力してください"
              rows="3"
            />
          </div>

          <div className="modal-actions">
            <button className="btn btn-secondary" onClick={() => setShowCompanyModal(false)}>
              キャンセル
            </button>
            <button 
              className="btn btn-primary" 
              onClick={handleSaveCompany}
              disabled={!companyForm.company_code || !companyForm.company_name}
            >
              {editingCompany ?'更新' : '登録'}
            </button>
          </div>
        </Modal>
      )}
    </div>
  );
}

export default Companies;
